





















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Data from "../../../store/entities/data";
import moment from "moment";
import Equipment from "@/store/entities/equipment";
class PagefactoryRequest{
}
@Component
export default class EditSmokecrib extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  data: Data = new Data();
  equipment: Equipment = new Equipment();
  status:string = "0";
  save() {
    (this.$refs.smokecribForm as any).validate(async (valid: boolean) => {
      if (valid) {
          if(this.status == "0"){
              this.data["status"] = 0;
          }else if(this.status == "1"){
              this.data["status"] = 1;
          }
          if(this.data["analyseTime"] != ""){
            //北京时间比世界时间相差8小时
            this.data["analyseTime"] = moment(this.data["analyseTime"]). utcOffset(480).format( 'YYYY-MM-DD HH:mm:ss');
          }
        await this.$store.dispatch({
          type: "data/update",
          data: this.data,
        }); 
        console.log(this.data);
        this.equipment["numbler"] = this.data["numbler"];
        this.equipment["Id"] = this.data["eId"]
        await this.$store.dispatch({
          type: "equipment/updateNumbler",
          data: this.equipment,
        });
        (this.$refs.smokecribForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
        this.status = "0";
      }
    });
  }
  cancel() {
    (this.$refs.smokecribForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.data = Util.extend(true, {}, this.$store.state.data.editStatus);
      if(this.data["analyseTime"] == "0001-01-01T00:00:00"){
        this.data["analyseTime"] = new Date();
      }
      if(this.data["status"] == 1){
          this.status = "1";
      }
    }
  }
   smokecribRule = {
    numbler: [{transform: (value) => String(value), required: true, message: "请填写虫子数量", trigger: "blur" }],
    status:[{type:"number", required: true, message: "请选择状态", trigger: "change" }],
    analyseTime: [{type:"date",required: true, message: "请选择分析时间", trigger: "blur" }],
  };
}
